import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Force leaflet default icon to work in bundler
const redIcon = L.divIcon({
  className: "",
  html: `<div style="background:#FF3B30;width:14px;height:14px;border-radius:50%;box-shadow:0 0 0 4px rgba(255,59,48,0.25),0 0 18px rgba(255,59,48,0.8);"></div>`,
  iconSize: [14, 14],
  iconAnchor: [7, 7],
});

export default function EmployeeMap({ points = [] }) {
  const mapRef = useRef(null);
  const containerRef = useRef(null);
  const markersRef = useRef([]);

  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;
    const map = L.map(containerRef.current, {
      zoomControl: false,
      attributionControl: true,
    }).setView([44.3, -78.33], 5); // Canada-ish default (Peterborough ON area)
    // Dark tiles
    L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", {
      subdomains: "abcd",
      maxZoom: 19,
      attribution: "© OpenStreetMap contributors © CARTO",
    }).addTo(map);
    L.control.zoom({ position: "bottomright" }).addTo(map);
    mapRef.current = map;
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    markersRef.current.forEach((m) => m.remove());
    markersRef.current = [];
    const valid = points.filter((p) => typeof p.lat === "number" && typeof p.lng === "number");
    valid.forEach((p) => {
      const m = L.marker([p.lat, p.lng], { icon: redIcon }).addTo(map);
      m.bindPopup(`<div style="font-family:Manrope,sans-serif;color:#fff;"><b>${p.user_name || "Employee"}</b><br/><span style="color:#8E8E93;font-size:11px;">${new Date(p.clock_in_at).toLocaleString()}</span><br/><span style="color:#d4d4d8;font-size:11px;">${p.address || ""}</span></div>`);
      markersRef.current.push(m);
    });
    if (valid.length > 0) {
      const bounds = L.latLngBounds(valid.map((p) => [p.lat, p.lng]));
      if (valid.length === 1) map.setView([valid[0].lat, valid[0].lng], 13);
      else map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
    }
  }, [points]);

  return <div ref={containerRef} className="w-full h-full rounded-xl overflow-hidden border border-white/10" data-testid="employee-map" style={{ minHeight: 320 }} />;
}
